(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bimmerfit-carplay-choice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bimmerfit-carplay-choice')) {
    let choiceSequence = 0;

    class BimmerfitCarplayChoice extends HTMLElement {
      #controller;
      #headunit;
      #connector;
      #connectorLabel;
      #results;
      #panels;

      connectedCallback() {
        this.#controller?.abort();
        this.#headunit = this.querySelector('[data-bf-choice-headunit]');
        this.#connector = this.querySelector('[data-bf-choice-connector]');
        this.#connectorLabel = this.querySelector('[data-bf-choice-connector-label]');
        this.#results = this.querySelector('[data-bf-choice-results]');
        this.#panels = [...this.querySelectorAll('[data-bf-choice-result]')];
        const controls = this.querySelector('[data-bf-choice-controls]');
        const button = this.querySelector('[data-bf-choice-button]');
        const headunitLabel = this.querySelector('[data-bf-choice-headunit-label]');
        const required = ['unknown', 'mgu', 'nbt_evo_id56', 'nbt_evo_id4', 'entrynav2_absent', 'entrynav2_check'];
        if (!controls || !button || !headunitLabel || !this.#headunit || !this.#connector || !this.#connectorLabel || !this.#results || required.some(key => !this.#panels.some(panel => panel.dataset.bfChoiceResult === key && panel.querySelector('p')))) return;
        this.#controller = new AbortController();
        const options = { signal: this.#controller.signal };
        let prefix;
        do {
          prefix = `bf-carplay-choice-${++choiceSequence}`;
        } while (document.getElementById(`${prefix}-headunit`) || document.getElementById(`${prefix}-results`));
        this.#headunit.id = `${prefix}-headunit`;
        this.#connector.id = `${prefix}-connector`;
        headunitLabel.htmlFor = this.#headunit.id;
        this.#connectorLabel.htmlFor = this.#connector.id;
        this.#results.id = `${prefix}-results`;
        button.setAttribute('aria-controls', this.#results.id);
        this.#panels.forEach(panel => {
          panel.querySelector('p').id = `${prefix}-${panel.dataset.bfChoiceResult}`;
        });
        this.#headunit.value = 'unknown';
        this.#connector.value = 'unknown';
        this.#headunit.addEventListener('change', () => this.#change(), options);
        this.#connector.addEventListener('change', () => this.#change(), options);
        button.addEventListener('click', () => this.#show(this.#route(), true), options);
        controls.hidden = false;
        this.#change();
      }

      disconnectedCallback() {
        this.#controller?.abort();
        this.#controller = undefined;
        const controls = this.querySelector('[data-bf-choice-controls]');
        if (controls) controls.hidden = true;
        this.#panels?.forEach(panel => { panel.hidden = false; });
        this.#results?.removeAttribute('aria-describedby');
      }

      #route() {
        if (this.#headunit.value === 'entrynav2') return this.#connector.value === 'confirmed_absent' ? 'entrynav2_absent' : 'entrynav2_check';
        return ['mgu', 'nbt_evo_id56', 'nbt_evo_id4'].includes(this.#headunit.value) ? this.#headunit.value : 'unknown';
      }

      #change() {
        if (!this.isConnected) return;
        this.#connectorLabel.hidden = this.#headunit.value !== 'entrynav2';
        if (this.#headunit.value !== 'entrynav2') this.#connector.value = 'unknown';
        this.#show('unknown', false);
      }

      #show(key, moveFocus) {
        if (!this.isConnected) return;
        const selected = this.#panels.find(panel => panel.dataset.bfChoiceResult === key);
        this.#panels.forEach(panel => { panel.hidden = panel !== selected; });
        this.#results.setAttribute('aria-describedby', selected.querySelector('p').id);
        if (moveFocus) this.#results.focus();
      }
    }

    customElements.define('bimmerfit-carplay-choice', BimmerfitCarplayChoice);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bimmerfit-contact-guard"] && !Shopify.designMode) return;
  try {
    const contactOverlapClass = 'bf-contact-purchase-overlap';
  const purchaseSelector = 'button[name="add"], button[name="checkout"], #checkout, .shopify-payment-button, .sticky-add-to-cart__button';
  let contactFramePending = false;

  function contactRectsOverlap(contact, purchase) {
    return purchase.width > 0 && purchase.height > 0 &&
      purchase.bottom > 0 && purchase.top < window.innerHeight &&
      purchase.right > 0 && purchase.left < window.innerWidth &&
      contact.left < purchase.right && contact.right > purchase.left &&
      contact.top < purchase.bottom && contact.bottom > purchase.top;
  }

  function updateContactPurchaseOverlap() {
    contactFramePending = false;
    const purchaseControls = Array.from(document.querySelectorAll(purchaseSelector));
    document.querySelectorAll('a.bf-whatsapp').forEach((contact) => {
      const contactStyle = window.getComputedStyle(contact);
      const contactRect = contact.getBoundingClientRect();
      const hideContact = contactStyle.position === 'fixed' &&
        !contact.contains(document.activeElement) && purchaseControls.some((control) => {
          const controlStyle = window.getComputedStyle(control);
          return controlStyle.visibility !== 'hidden' && controlStyle.display !== 'none' &&
            contactRectsOverlap(contactRect, control.getBoundingClientRect());
        });
      if (contact.classList.contains(contactOverlapClass) !== hideContact) {
        contact.classList.toggle(contactOverlapClass, hideContact);
      }
    });
  }

  function scheduleContactPurchaseCheck() {
    if (contactFramePending) return;
    contactFramePending = true;
    window.requestAnimationFrame(updateContactPurchaseOverlap);
  }

  document.addEventListener('scroll', scheduleContactPurchaseCheck, { passive: true, capture: true });
  document.addEventListener('focusin', scheduleContactPurchaseCheck);
  document.addEventListener('focusout', scheduleContactPurchaseCheck);
  window.addEventListener('resize', scheduleContactPurchaseCheck, { passive: true });
  window.addEventListener('pageshow', scheduleContactPurchaseCheck);
  new MutationObserver(scheduleContactPurchaseCheck).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'open']
  });
  scheduleContactPurchaseCheck();
  } catch(e) { console.error(e); }
})();

})();
